import Barcode from "components/Commons/BarCode"
import { forwardRef } from "react"

interface ManifestoData {
  courierName: string
  numeroManifesto: string
  cliente: string
  fechaCierre: string
  totalEnvios: number
  totalBultos: number
  paginas: string
  destinatarios: Array<{
    nro: number
    destinatario: string
    comuna: string
    referencia: string
    seguimiento: string
    bultos: string
  }>
  clienteInfo: {
    nombreRutFirma: string
  }
  transporteInfo: {
    fechaHoraRetiro: string
    nombreRut: string
    cantidadPalletsRetirados: string
    firma: string
  }
  admisionInfo: {
    nombreRutFirma: string
  }
}

interface ManifestoPrintBodyProps {
  data: ManifestoData
}

const ManifestoPrintBody = forwardRef<HTMLDivElement, ManifestoPrintBodyProps>(
  ({ data }, ref) => {
    return (
      <div ref={ref} className="manifesto-print-container">
        {/* Header */}
        <div className="header-section">
          <h1 className="manifesto-title">MANIFESTO RESUMEN</h1>
        </div>

        {/* Info Section */}
        <div className="info-section">
          <div className="company-logo">
            <div className="logo-box">{data?.courierName}</div>
          </div>
          <div className="manifesto-info">
            <div className="info-grid">
              <div className="info-row">
                <span className="label">NÚMERO MANIFESTO:</span>
                <span className="value">{data.numeroManifesto}</span>
                <span className="label">FECHA DE CIERRE MANIFESTO:</span>
                <span className="value">{data.fechaCierre}</span>
              </div>
              <div className="info-row">
                <span className="label">CLIENTE:</span>
                <span className="value">{data.cliente}</span>
                <span className="label">PÁGINAS:</span>
                <span className="value">{data.paginas}</span>
              </div>
              {/* <div className="info-row">
                <span className="empty"></span>
                <span className="empty"></span>
                <span className="empty"></span>
                <span className="empty"></span>
              </div>
              <div className="info-row">
                <span className="empty"></span>
                <span className="empty"></span>
                <span className="empty"></span>
                <span className="empty"></span>
              </div> */}
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="table-section">
          <table className="manifesto-table">
            <thead>
              <tr>
                <th>NRO</th>
                <th>DESTINATARIO</th>
                <th>COMUNA</th>
                <th>REFERENCIA</th>
                <th>SEGUIMIENTO</th>
                {/* <th>BULTOS</th> */}
              </tr>
            </thead>
            <tbody>
              {data.destinatarios.map((destinatario, index) => (
                <tr key={index}>
                  <td>{destinatario.nro}</td>
                  <td>{destinatario.destinatario}</td>
                  <td>{destinatario.comuna}</td>
                  <td>{destinatario.referencia}</td>
                  <td className="barcode-cell">
                    <div className="barcode-container">
                      <Barcode value={destinatario.seguimiento} height={10} displayValue={false} />
                      <div className="barcode-number">{destinatario.seguimiento}</div>
                    </div>
                  </td>
                  {/* <td>{destinatario.bultos}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer Section */}
        <div className="footer-section">
          <table className="footer-table">
            <thead>
              <tr>
                <th>CLIENTE</th>
                <th>TRANSPORTE</th>
                <th>ADMISIÓN</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="signature-section">
                  </div>
                </td>
                <td>
                  <div className="signature-section">
                    <div className="signature-line">FECHA Y HORA RETIRO</div>
                    <div className="signature-line">NOMBRE Y RUT</div>
                    <div className="signature-line">FIRMA</div>
                  </div>
                </td>
                <td>
                  <div className="signature-section">
                  </div>
                </td>
              </tr>
              <tr>
                <td>{data.clienteInfo.nombreRutFirma}</td>
                <td></td>
                <td>{data.clienteInfo.nombreRutFirma}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Manifesto Number Footer */}
        <div className="manifesto-footer">
          Manifesto Número: {data.numeroManifesto} / Hoja: {data.paginas}
        </div>

        <style>
          {`
          .manifesto-print-container {
            width: 210mm;
            padding: 20mm;
            margin: 0 auto;
            background: white;
            font-family: Arial, sans-serif;
            font-size: 10px;
            line-height: 1.2;
            color: black;
          }

          .header-section {
            text-align: center;
            margin-bottom: 20px;
          }

          .manifesto-title {
            font-size: 18px;
            font-weight: bold;
            margin: 0;
          }

          .info-section {
            display: flex;
            margin-bottom: 20px;
            border: 2px solid black;
          }

          .company-logo {
            border-right: 2px solid black;
            padding: 10px;
            width: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .logo-box {
            font-weight: bold;
            font-size: 14px;
            text-align: center;
          }

          .manifesto-info {
            flex: 1;
            padding: 10px;
          }

          .info-grid {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .info-row {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            gap: 10px;
            align-items: center;
          }

          .label {
            font-weight: bold;
            font-size: 9px;
          }

          .value {
            font-size: 9px;
          }

          .empty {
            height: 12px;
          }

          .table-section {
            margin-bottom: 20px;
          }

          .manifesto-table {
            width: 100%;
            border-collapse: collapse;
            border: 2px solid black;
          }

          .manifesto-table th,
          .manifesto-table td {
            border: 1px solid black;
            padding: 8px 4px;
            text-align: center;
            font-size: 9px;
          }

          .manifesto-table th {
            background-color: #f0f0f0;
            font-weight: bold;
          }

          .barcode-cell {
            padding: 4px;
          }

          .barcode-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2px;
          }

          .barcode-bars {
            font-family: 'Courier New', monospace;
            font-size: 12px;
            letter-spacing: -1px;
            line-height: 1;
          }

          .barcode-number {
            font-size: 8px;
            font-weight: bold;
          }

          .footer-section {
            margin-bottom: 20px;
          }

          .footer-table {
            width: 100%;
            border-collapse: collapse;
            border: 2px solid black;
          }

          .footer-table th,
          .footer-table td {
            border: 1px solid black;
            padding: 8px;
            text-align: center;
            font-size: 9px;
            vertical-align: top;
          }

          .footer-table th {
            background-color: #f0f0f0;
            font-weight: bold;
          }

          .signature-section {
            display: flex;
            flex-direction: column;
            gap: 4px;
            text-align: left;
          }

          .signature-line,
          .signature-value {
            font-size: 8px;
            min-height: 12px;
          }

          .signature-line {
            font-weight: bold;
          }

          .manifesto-footer {
            text-align: left;
            font-size: 9px;
            margin-top: 10px;
          }

          @media print {
            .manifesto-print-container {
              margin: 0;
              padding: 10mm;
            }
          }
          `}
        </style>
      </div>
    )
  }
)

ManifestoPrintBody.displayName = "ManifestoPrintBody"

export default ManifestoPrintBody